import {
	primaryColor,
	warningColor,
	dangerColor,
	successColor,
	infoColor,
	roseColor,
	grayColor,
	whiteColor,
} from 'assets/jss/material-dashboard-pro-react';

const badgeStyle = (theme) => ({
	dot: {
		borderRadius: '50%',
		padding: '4px',
		color: whiteColor,
		marginRight: '8px',
	},
	badge: {
		display: 'inline-flex',
		alignItems: 'center',
		pointerEvents: 'none',
		'& p': {
			marginBottom: 0,
			fontFamily: theme.fontFamily.albert.bold,
		},
	},
	filledBadge: {
		color: whiteColor,
		display: 'inline-flex',
		padding: theme.direction === 'rtl' ? '3px 4px 1px' : '6px 8px',
		borderRadius: '2px',
		marginRight: '4px',
		'& p': {
			marginBottom: 0,
			fontFamily: theme.fontFamily.albert.bold,
			lineHeight: theme.direction === 'rtl' ? 1.2 : 'normal',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			width: '100%',
		},
	},
	dotHidden: {
		display: 'none',
	},
	primary: {
		backgroundColor: primaryColor[0],
	},
	warning: {
		backgroundColor: warningColor[0],
	},
	danger: {
		backgroundColor: dangerColor[0],
	},
	success: {
		backgroundColor: successColor[0],
	},
	info: {
		backgroundColor: infoColor[0],
	},
	rose: {
		backgroundColor: roseColor[0],
	},
	gray: {
		backgroundColor: grayColor[0],
	},
});

export default badgeStyle;
